// extracted by mini-css-extract-plugin
export default {"wrapper":"Penetrate_wrapper__yeCBI","title":"Penetrate_title__epWHZ"};